import React from 'react';
import { Typography, Box, TextField, styled } from '@mui/material';
import {
    HrSimulation,
    SimulationDateString,
} from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { isDateInvalid } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/dataHelpers';
import { StyLoadingSkeleton, StyBlock } from './StyledComponents';
import { useTranslation } from 'react-i18next';

const StyTextField = styled(TextField)(() => ({
    '& .MuiFormHelperText-root': {
        backgroundColor: '#efefef',
        margin: 0,
    },
}));

const DateSelect = ({
    isLoading,
    gradeStartDate,
    onStartDateChange,
    onChanges,
    isUpdateEnabled,
    hrSimulation,
}: {
    onChanges: (hasGradeChanges: boolean) => void;
    isLoading: boolean;
    gradeStartDate: SimulationDateString;
    onStartDateChange: (gradeStartDate: SimulationDateString) => void;
    isUpdateEnabled: boolean;
    hrSimulation: HrSimulation;
}): React.ReactElement => {
    const { t } = useTranslation();
    const isError = isDateInvalid({
        gradeStartDate,
        startDate: hrSimulation.startDate,
        endDate: hrSimulation.endDate,
    });

    return (
        <StyBlock>
            <Typography variant="h5" color="primary" sx={{ opacity: 0 }}>
                {t('common.date')}
            </Typography>
            <Box>
                <Typography variant="body1">
                    {t('humanResources.simulation.gradeHypothesis.startDate')}
                </Typography>
                {isLoading ? (
                    <StyLoadingSkeleton />
                ) : (
                    <StyTextField
                        error={isError}
                        variant="outlined"
                        value={gradeStartDate}
                        size="small"
                        type="date"
                        onChange={(e) => {
                            onStartDateChange(
                                e.target.value as SimulationDateString,
                            );
                            onChanges(true);
                        }}
                        sx={{ backgroundColor: 'white', marginTop: '5px' }}
                        disabled={!isUpdateEnabled}
                        helperText={
                            isError
                                ? t(
                                      'humanResources.simulation.gradeHypothesis.invalidDate',
                                  )
                                : ''
                        }
                        InputProps={{
                            inputProps: {
                                min: hrSimulation.startDate,
                                max: hrSimulation.endDate,
                            },
                        }}
                    />
                )}
            </Box>
        </StyBlock>
    );
};
export default DateSelect;
